export default function ({state, getters, commit, dispatch}, vm) {
  if (state.form.UsersSum > state.form.Sum) {
    window.app.$notify.error({
      title: 'Ошибка',
      message: 'Сумма бюджета не может быть меньше сумм дотаций'
    });
    return
  }
  let dataForm = getters['form/data'];
  commit('loading', true);
  let data = '';
  for (let k in dataForm) {
    switch (k) {
      case 'StartDate':
      case 'EndDate':
      case 'IssueDate':
        data += 'Certificate[' + k + '][Serialized]=' + dataForm[k].Serialized + '&';
        break;
      default:
        data += 'Certificate[' + k + ']=' + dataForm[k] + '&'
    }
  }
  data += 'IsSubsidies=true';
  axios({
    method: 'post',
    url: '/tourclient/api/giftCertificate',
    data,
  }).then(({data}) => {
    commit('loading');
    if (HasError(data, {text: 'При сохранении возникла ошибка'})) return;
    vm.$emit('add', state);
    setTimeout(() => {
      dispatch('clean');
    })
  }).catch(e => {
    if (!e) return;
    dispatch('clean');
    dispatch('error', e, {root: true});
  })
}